var _circle, _circle2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHalfLeaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5541,
    cy: 22.4593,
    r: 22.3304,
    fill: "url(#paint0_linear_1_14019)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5541,
    cy: 22.4593,
    r: 22.3304,
    fill: "#FFF9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4468 12.55C19.1462 12.6571 18.8528 12.7759 18.5668 12.9064M15.7674 14.7126C15.5181 14.9305 15.2788 15.1595 15.0502 15.399M13.1351 18.1215C12.9297 18.5322 12.7512 18.9564 12.5994 19.3942M12.0175 22.3312C11.9933 22.7591 11.9944 23.1958 12.0197 23.6237M12.6247 26.5926C12.7713 27.0033 12.9415 27.4029 13.1351 27.7916M14.96 30.4173C15.2284 30.7055 15.5118 30.979 15.8103 31.2379M18.3534 32.9066C18.7898 33.1172 19.2396 33.2987 19.6998 33.45M22.9998 34C29.0751 34 33.9998 29.0753 33.9998 23C33.9998 16.9247 29.0751 12 22.9998 12",
    stroke: "#F5CD47",
    strokeWidth: 2.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 24.6504C23.4374 24.6504 23.8571 24.4766 24.1666 24.1671C24.476 23.8577 24.6498 23.438 24.6498 23.0004C24.6498 22.5628 24.476 22.1431 24.1666 21.8337C23.8571 21.5242 23.4374 21.3504 22.9998 21.3504M22.9998 24.6504C22.5622 24.6504 22.1426 24.4766 21.8331 24.1671C21.5237 23.8577 21.3499 23.438 21.3499 23.0004C21.3499 22.5628 21.5237 22.1431 21.8331 21.8337C22.1426 21.5242 22.5622 21.3504 22.9998 21.3504M22.9998 24.6504V27.4004M22.9998 21.3504V16.4004",
    stroke: "#F5CD47",
    strokeWidth: 2.0229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_14019",
    x1: 18.1665,
    y1: -1.50098,
    x2: 44.6665,
    y2: 43.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00345C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfLeaveIcon);
export default __webpack_public_path__ + "static/media/HalfLeaveIcon.9f0eff5b824ca0cd9c7b9ef818e9fa98.svg";
export { ForwardRef as ReactComponent };